import { Edit, SimpleForm, TextField, TextInput } from 'react-admin';
import { CustomTitle } from '../../components/CustomTitle';

export const DateEdit = (props: unknown) => (
  <Edit {...props} title={<CustomTitle />}>
    <SimpleForm>
      <TextField source="id" />
      <TextInput source="date" type="date" />
      <TextInput source="firstSessionStart" type="time" />
      <TextInput source="lastSessionEnd" type="time" />
    </SimpleForm>
  </Edit>
);
